import { Skeleton } from "@mui/material";
import { Col, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import BMXSeparator from "../../../../../Components/Separator/BMXSeparator";
import InputSkeleton from "../../../../../Components/Skeletons/InputSkeleton";
 
const DeviceOtherFormSkeleton = () => {
  const { t } = useTranslation();
  return (
    <div className="d-grid">
      <Row style={{ height: "100%" }}>
        <Col
          className="d-flex flex-column justify-content-start align-items-start "
          xs={2}
          style={{ height: "100%" }}
        >
          <Row>
            <Col
              className="d-flex flex-column justify-content-start align-items-start mt-2"
              xs={3}
            >
              <Row>
                <Col>
                  <Skeleton
                    animation="wave"
                    variant="text"
                    sx={{ fontSize: "1.5rem", width: "10vmax" }}
                  />
                </Col>
              </Row>
              <Row className="mt-2">
                <Col>
                  <Skeleton
                    animation="wave"
                    variant="text"
                    sx={{ fontSize: "1", width: "10vmax" }}
                  />
                </Col>
              </Row>
            </Col>
          </Row>
        </Col>
        <Col style={{ height: "100%" }}>
          <Row style={{ height: "100%" }}>
            <Col xs={8}>
              <BMXSeparator title={t("global:device.device")} />
              <Row className="mt-4">
                <Col xs={{ span: 4 }}>
                  <InputSkeleton />
                </Col>
                <Col xs={{ span: 4 }}>
                  <InputSkeleton />
                </Col>
                <Col xs={{ span: 4 }}>
                  <InputSkeleton />
                </Col>
              </Row>
              <Row className="mt-4">
                <Col xs={12}>
                  <InputSkeleton />
                </Col>
              </Row>
              <Row className="mt-4">
                <Col xs={12}>
                  <InputSkeleton />
                </Col>
              </Row>
              <Row style={{ marginTop: "105px" }}>
                <Col xs={4}>
                  <InputSkeleton />
                </Col>
                <Col xs={4}>
                  <InputSkeleton />
                </Col>
              </Row>
              <Row className="mt-4">
                <Col xs={{ span: 3 }}>
                  <InputSkeleton />
                </Col>

                <Col xs={3}>
                  <InputSkeleton />
                </Col>
                <Col xs={3}>
                  <InputSkeleton />
                </Col>
                <Col xs={3}>
                  <InputSkeleton />
                </Col>
              </Row>
              <Row className="mt-4">
                <Col xs={4}>
                  <InputSkeleton />
                </Col>
                <Col xs={4}>
                  <InputSkeleton />
                </Col>
                <Col xs={4}>
                  <InputSkeleton />
                </Col>
              </Row>
            </Col>
            <Col xs={4}>
              <BMXSeparator title={t("global:device.client")} />
              <Row>
                <Col xs={12}>
                  <InputSkeleton />
                </Col>
              </Row>
              <Row className="mt-4">
                <Col xs={12}>
                  <InputSkeleton />
                </Col>
              </Row>
              <Row className="mt-4">
                <Col xs={12}>
                  <InputSkeleton />
                </Col>
              </Row>
              <Row className="mt-4">
                <Col xs={12}>
                  <InputSkeleton />
                </Col>
              </Row>
              <Row style={{ marginTop: "105px" }}>
                <Col xs={12}>
                  <InputSkeleton />
                </Col>
              </Row>
            </Col>
          </Row>
        </Col>
      </Row>
    </div>
  );
};

export default DeviceOtherFormSkeleton;
